module.exports = "/img/main_banner.svg?c5ee3baed97efbb0187975e66009f0f3";